var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-cover main-progress"},[_c('div',{staticClass:"progress-fluent-line progress-primary progress-medium"},[_c('span',{staticClass:"progress-span"}),_c('span',{staticClass:"progress-span"}),_c('span',{staticClass:"progress-span"}),_c('span',{staticClass:"progress-span"}),_c('span',{staticClass:"progress-span"})])])
}]

export { render, staticRenderFns }